import { HR } from 'foundations-components/transitional/components/HR';
import ViewerRelatedConditionsHeadingText from './ViewerRelatedConditionsHeadingText';
import { useFlexibleAssociations } from '../../hooks/useFlexibleAssociations';
import styled from 'foundations-theming/utils';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import ViewerAssociatedCrmObjectHeadingSubtext from './ViewerAssociatedCrmObjectHeadingSubtext';
import ViewerUnifiedEventRefinementsDisplay from './ViewerUnifiedEventRefinementsDisplay';
import LogicGroupError from '../common/LogicGroupError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ViewerRelatedConditionsHeadingTextWrapper = styled.div.withConfig({
  displayName: "FiltersDisplayRelatedConditionsHeading__ViewerRelatedConditionsHeadingTextWrapper",
  componentId: "sc-11jowq3-0"
})(() => ({
  overflowWrap: 'break-word'
}));
const ViewerAssociatedCrmObjectHeadingSubtextWrapper = styled.div.withConfig({
  displayName: "FiltersDisplayRelatedConditionsHeading__ViewerAssociatedCrmObjectHeadingSubtextWrapper",
  componentId: "sc-11jowq3-1"
})(({
  theme
}) => ({
  overflowWrap: 'break-word',
  paddingLeft: theme.space[500],
  paddingTop: theme.space[100]
}));
const FiltersDisplayRelatedConditionsHeading = props => {
  const {
    conditionPath,
    logicGroup
  } = props;
  const {
    isAssnBranch
  } = useFlexibleAssociations(logicGroup, conditionPath);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TFlex, {
      align: "center",
      justify: "between",
      children: /*#__PURE__*/_jsxs(ViewerRelatedConditionsHeadingTextWrapper, {
        children: [/*#__PURE__*/_jsx(ViewerRelatedConditionsHeadingText, {
          logicGroup: logicGroup,
          conditionPath: conditionPath
        }), /*#__PURE__*/_jsx(ViewerUnifiedEventRefinementsDisplay, {
          logicGroup: logicGroup
        })]
      })
    }), /*#__PURE__*/_jsx(LogicGroupError, {
      logicGroup: logicGroup,
      showLogicGroupErrors: true,
      spaceStyleProps: {
        marginBlockStart: '0',
        marginInlineStart: '100'
      }
    }), isAssnBranch && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HR, {
        "data-test-id": "association-divider",
        marginBlock: "100"
      }), /*#__PURE__*/_jsx(ViewerAssociatedCrmObjectHeadingSubtextWrapper, {
        children: /*#__PURE__*/_jsx(ViewerAssociatedCrmObjectHeadingSubtext, {
          logicGroup: logicGroup
        })
      })]
    })]
  });
};
export default FiltersDisplayRelatedConditionsHeading;